import { Outlet } from 'react-router-dom';

export const ServiceAccounts: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <Outlet />
    </div>
  );
};
